module.exports = __webpack_public_path__ + "img/thin.9b34088.svg";